import Localization from "../../../../localization";
import { Modal } from "../../../../components";
import ClosestCircle from "./closestCircle";
import useViewModel from "../../viewModel";
import Section from "./section";
import { useRef } from "react";

const ClosestCircleSection = () => {
  const { group: { nrOfMembers = 0 } = {} } = useViewModel();
  const closestCircleModalRef = useRef();

  return (
    <>
      <Section
        title={Localization.general.my_closest_circle}
        desc={Localization.service_edit_collaborators.invite_desc}
        subtitle={`${nrOfMembers} ${
          nrOfMembers == 1
            ? Localization.general.person
            : Localization.general.people
        }`.toLocaleLowerCase()}
        buttons={[
          {
            title: Localization.general.edit,
            onClick: () => closestCircleModalRef.current.open(),
          },
        ]}
      />
      <Modal
        ref={closestCircleModalRef}
        title={Localization.general.my_closest_circle}
        child={() => (
          <ClosestCircle
            onDone={() => closestCircleModalRef.current.close()}
            onCancel={() => closestCircleModalRef.current.close()}
          />
        )}
      />
    </>
  );
};

export default ClosestCircleSection;
